import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleSidenavFullWidth } from "../../features/global/globalSlice";
import checked from "../../assets/checked.png";
import { Descriptions, Spin, Tabs } from "antd";
import ExperienceTab from "./tabs/ExperienceTab";
import EducationTab from "./tabs/EducationTab";
import CertificateTab from "./tabs/CertificateTab";
import {
  handleStepCurrent,
  fetchProfile,
} from "../../features/profile/profileSlice";
import dayjs from "dayjs";

export default function MainProfile({ profileApplication }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { profileData, profileLoading } = useSelector(
    (state) => state.profile
  );

  const [editProfile, seteditProfile] = useState(false);

  useEffect(() => {
    dispatch(handleSidenavFullWidth(false));
    dispatch(fetchProfile());
  }, [dispatch]);

  async function handleProfileBuilder(e) {
    e.preventDefault();
    await dispatch(handleStepCurrent(0));
    await navigate("/profile-builder");
  }

  const items = [
    {
      key: "1",
      label: <span className="profile-basic-info !font-[500]">Full Name</span>,
      children: (
        <span className="profile-basic-info !font-[400]">
          {profileData?.firstName} {profileData?.middleName}{" "}
          {profileData?.lastName}
        </span>
      ),
    },
    {
      key: "2",
      label: (
        <span className="profile-basic-info !font-[500]">National ID No.</span>
      ),
      children: (
        <span className="profile-basic-info !font-[400]">
          {profileData?.nationalId}
        </span>
      ),
    },
    {
      key: "3",
      label: <span className="profile-basic-info !font-[500]">Email</span>,
      children: (
        <span className="profile-basic-info !font-[400]">
          {profileData?.email}
        </span>
      ),
    },
    {
      key: "4",
      label: (
        <span className="profile-basic-info !font-[500]">Phone Number</span>
      ),
      children: (
        <span className="profile-basic-info !font-[400]">
          {profileData?.phoneNumber}
        </span>
      ),
    },
    {
      key: "5",
      label: (
        <span className="profile-basic-info !font-[500]">Nationality</span>
      ),
      children: (
        <span className="profile-basic-info !font-[400]">
          {profileData?.nationality}
        </span>
      ),
    },
    {
      key: "6",
      label: <span className="profile-basic-info !font-[500]">County</span>,
      children: (
        <span className="profile-basic-info !font-[400]">
          {profileData?.county}
        </span>
      ),
    },
    {
      key: "7",
      label: (
        <span className="profile-basic-info !font-[500]">Date of Birth</span>
      ),
      children: (
        <span className="profile-basic-info !font-[400]">
          {profileData?.dateOfBirth
            ? dayjs(profileData.dateOfBirth).format("DD MMM YYYY")
            : "N/A"}
        </span>
      ),
    },
    {
      key: "8",
      label: <span className="profile-basic-info !font-[500]">Gender</span>,
      children: (
        <span className="profile-basic-info !font-[400]">
          {profileData?.gender}
        </span>
      ),
    },
    {
      key: "9",
      label: (
        <span className="profile-basic-info !font-[500]">Marital Status</span>
      ),
      children: (
        <span className="profile-basic-info !font-[400]">
          {profileData?.maritalStatus}
        </span>
      ),
    },
    {
      key: "10",
      label: <span className="profile-basic-info !font-[500]">Ethnicity</span>,
      children: (
        <span className="profile-basic-info !font-[400]">
          {profileData?.ethnicity}
        </span>
      ),
    },
    {
      key: "11",
      label: <span className="profile-basic-info !font-[500]">Religion</span>,
      children: (
        <span className="profile-basic-info !font-[400]">
          {profileData?.religion}
        </span>
      ),
    },
    {
      key: "12",
      label: (
        <span className="profile-basic-info !font-[500]">Has Disability</span>
      ),
      children: (
        <span className="profile-basic-info !font-[400]">
          {profileData?.hasDisability ? "Yes" : "No"}
        </span>
      ),
    },
  ];

  const jobSeeker = [
    {
      key: "1",
      label: (
        <span className="profile-basic-info !font-[500]">Career Title</span>
      ),
      children: (
        <span className="profile-basic-info !font-[400]">
          {profileData?.jobCareerTitle || "N/A"}
        </span>
      ),
    },
    {
      key: "2",
      label: (
        <span className="profile-basic-info !font-[500]">Current Job</span>
      ),
      children: (
        <span className="profile-basic-info !font-[400]">
          {profileData?.currentJob || "N/A"}
        </span>
      ),
    },
    {
      key: "3",
      label: (
        <span className="profile-basic-info !font-[500]">
          Job Seeking Methods
        </span>
      ),
      children: (
        <span className="profile-basic-info !font-[400]">
          {profileData?.jobSeekingMethods?.length
            ? profileData.jobSeekingMethods.join(", ")
            : "N/A"}
        </span>
      ),
    },
  ];

  const profileTabs = useMemo(() => [
    {
      label: <span className="ml-2">Experience</span>,
      key: "0",
      children: (
        <ExperienceTab
          profileApplication={profileApplication}
          editProfile={editProfile}
        />
      ),
    },
    {
      label: <span className="ml-2">Education</span>,
      key: "1",
      children: (
        <EducationTab
          profileApplication={profileApplication}
          editProfile={editProfile}
        />
      ),
    },
    {
      label: <span className="ml-2">Certificates</span>,
      key: "2",
      children: (
        <CertificateTab
          profileApplication={profileApplication}
          editProfile={editProfile}
        />
      ),
    },
  ], [profileApplication, editProfile]);

  if (profileLoading && !profileData) {
    return (
      <div className="flex items-center justify-center mt-20">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <>
      <div className="m-[10px] md:mr-[108px] md:ml-[42px] md:mt-[15px]">
        <div>
          <h2 className="prof-name">Profile</h2>
          <p className="prof-desc mt-2">Fill in your profile.</p>

          <div className="flex flex-wrap justify-end gap-3 md:gap-10">
            <div className="flex items-center justify-end">
              <button
                className="bg-white rounded-[35px] text-darkBlue border-2 border-darkBlue w-[199px] h-[46px] flex items-center justify-center"
                onClick={() => navigate("/job-vacancies")}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  className="mt-3"
                >
                  <path
                    d="M9.5 1.73333C12.7732 1.73333 15.6923 3.57933 17.1173 6.5C15.6923 9.42067 12.7818 11.2667 9.5 11.2667C6.21818 11.2667 3.30773 9.42067 1.88273 6.5C3.30773 3.57933 6.22682 1.73333 9.5 1.73333ZM9.5 0C5.18182 0 1.49409 2.69533 0 6.5C1.49409 10.3047 5.18182 13 9.5 13C13.8182 13 17.5059 10.3047 19 6.5C17.5059 2.69533 13.8182 0 9.5 0ZM9.5 4.33333C10.6918 4.33333 11.6591 5.304 11.6591 6.5C11.6591 7.696 10.6918 8.66667 9.5 8.66667C8.30818 8.66667 7.34091 7.696 7.34091 6.5C7.34091 5.304 8.30818 4.33333 9.5 4.33333ZM9.5 2.6C7.35818 2.6 5.61364 4.35067 5.61364 6.5C5.61364 8.64933 7.35818 10.4 9.5 10.4C11.6418 10.4 13.3864 8.64933 13.3864 6.5C13.3864 4.35067 11.6418 2.6 9.5 2.6Z"
                    fill="#0170BD"
                  />
                </svg>
                <span className="ml-2">Apply Job</span>
              </button>
            </div>

            <div className="flex items-center justify-end">
              <button
                className="bg-white rounded-[35px] text-darkBlue border-2 border-darkBlue w-[199px] h-[46px] flex items-center justify-center"
                onClick={(e) => handleProfileBuilder(e)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M5 17.998H9.24C9.37161 17.9987 9.50207 17.9735 9.62391 17.9238C9.74574 17.874 9.85656 17.8007 9.95 17.708L16.87 10.778L19.71 7.99799C19.8037 7.90502 19.8781 7.79442 19.9289 7.67256C19.9797 7.5507 20.0058 7.42 20.0058 7.28799C20.0058 7.15597 19.9797 7.02527 19.9289 6.90341C19.8781 6.78155 19.8037 6.67095 19.71 6.57799L15.47 2.28799C15.377 2.19426 15.2664 2.11986 15.1446 2.06909C15.0227 2.01833 14.892 1.99219 14.76 1.99219C14.628 1.99219 14.4973 2.01833 14.3754 2.06909C14.2536 2.11986 14.143 2.19426 14.05 2.28799L11.23 5.11799L4.29 12.048C4.19732 12.1414 4.12399 12.2522 4.07423 12.3741C4.02446 12.4959 3.99924 12.6264 4 12.758V16.998C4 17.2632 4.10536 17.5176 4.29289 17.7051C4.48043 17.8926 4.73478 17.998 5 17.998ZM14.76 4.40799L17.59 7.23799L16.17 8.65799L13.34 5.82799L14.76 4.40799ZM6 13.168L11.93 7.23799L14.76 10.068L8.83 15.998H6V13.168ZM21 19.998H3C2.73478 19.998 2.48043 20.1033 2.29289 20.2909C2.10536 20.4784 2 20.7328 2 20.998C2 21.2632 2.10536 21.5176 2.29289 21.7051C2.48043 21.8926 2.73478 21.998 3 21.998H21C21.2652 21.998 21.5196 21.8926 21.7071 21.7051C21.8946 21.5176 22 21.2632 22 20.998C22 20.7328 21.8946 20.4784 21.7071 20.2909C21.5196 20.1033 21.2652 19.998 21 19.998Z"
                    fill="#147CBC"
                  />
                </svg>
                <span className="ml-2">Edit Profile</span>
              </button>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row mt-5">
          <div className="w-full md:w-[35%]">
            <div>
              <div className="card-main bg-white pb-14">
                <div className="cover-photo-main">
                  <img
                    src="https://kazi254.ke/myimages/OTP_IMAGES/ACCOUNT_OPENING/avatar.png"
                    alt="profile"
                    className="profile-main"
                  />
                </div>
                <div className="flex flex-col mb-20 pt-8 px-[36px]">
                  <div className="flex items-center mt-[15%]">
                    <span className="text-3xl text-extrabold w-full truncate">
                      {profileData?.firstName} {profileData?.lastName}
                    </span>

                    <img
                      className="w-11 object-contain ml-1"
                      src={checked}
                      alt="Verified"
                    />
                  </div>

                  <span className="prof-job mt-5">
                    {profileData?.jobCareerTitle}
                  </span>
                  <span className="prof-loc mt-1">
                    {profileData?.county}, Kenya
                  </span>

                  <div className="flex mt-10 mb-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_3177_18210)">
                        <path
                          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM16.23 18L12 15.45L7.77 18L8.89 13.19L5.16 9.96L10.08 9.54L12 5L13.92 9.53L18.84 9.95L15.11 13.18L16.23 18Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_3177_18210">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span className="prof-card-head ml-3">About me</span>
                  </div>

                  <span className="mt-2 prof-card-text">
                    {profileData?.bio ? profileData.bio : "N/A"}
                  </span>

                  <div className="flex mt-10 mb-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_3177_18210b)">
                        <path
                          d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM16.23 18L12 15.45L7.77 18L8.89 13.19L5.16 9.96L10.08 9.54L12 5L13.92 9.53L18.84 9.95L15.11 13.18L16.23 18Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_3177_18210b">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                    <span className="prof-card-head ml-3">Languages</span>
                  </div>

                  <div className="flex items-center flex-wrap mt-2">
                    {profileData?.languages?.map((lang) => (
                      <div
                        key={lang}
                        className="bg-lightPurple rounded-[63px] text-center px-5 py-1 mr-2 mb-3"
                      >
                        <span className="prof-card-badge">{lang}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full">
            <div className="bg-white py-6 px-3 w-full mt-4 md:mt-0 md:ml-6 h-fit pb-12">
              <Descriptions
                colon={false}
                size="middle"
                column={{ xs: 2, sm: 3, md: 4, lg: 5 }}
                title={
                  <span className="prof-info-head">Basic Information</span>
                }
                layout="vertical"
                items={items}
              />

              <div
                style={{
                  background: "#D8D8D88A",
                  height: "1px",
                  width: "100%",
                }}
                className="my-10"
              ></div>

              <span className="prof-info-head">Job Seeking Information</span>

              <Descriptions
                colon={false}
                size="middle"
                column={{ xs: 1, sm: 2, md: 3 }}
                title=""
                layout="vertical"
                items={jobSeeker}
                className="mt-4"
              />
            </div>

            <div className="bg-white p-6 w-full md:ml-6 h-fit pb-16 mt-5">
              <Tabs defaultActiveKey="1" items={profileTabs} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
